class ColetorDetails {
    constructor($element, $scope, gql) {
        this.$element = $element

        this.gql = gql

        this.$apply = $scope.$apply.bind($scope)
    }

    $onInit() {
        this.ever = new Promise(resolve => setTimeout(resolve, 10000))
    }

    createConfig(config) {
        const query = gql`
            mutation CreateColetorConfig($coletorId: String!, $empresaId: Int!, $diretorio: String!, $operacao: ColetorConfigOperacao, $documento: ColetorConfigDocumento) {
                config: createColetorConfig(coletorId: $coletorId, empresaId: $empresaId, diretorio: $diretorio, operacao: $operacao, documento: $documento) {
                    id
                    diretorio
                    status
                    empresa {
                        id
                        razaoSocial
                        raizCnpj
                    }      
                }
            }
        `

        const variables = {
            coletorId: this.coletor.id,
            empresaId: config.empresa.id,
            diretorio: config.diretorio,
            operacao: config.operacao
        }

        if (config.operacao == "DOWNLOAD") {
            variables["documento"] = config.documento
        }

        this.createPromise = this.gql.mutate(query, variables)
            .then(() => this.coletorConfig = undefined)
            .then(() => this.$apply())
            .catch(console.error)
    }

    deleteConfig(coletorConfig) {
        const query = gql`
            mutation DeleteColetorConfig($configId: Int!) {
                config: deleteColetorConfig(id: $configId) {
                    id
                }
            }
        `

        const variables = {
            configId: parseInt(coletorConfig.id)
        }

        Confirm
            .warning(
                'Deseja realmente remover esta configuração?',
                'A pasta configurada deixará de ser sincronizada.',
                {
                    'Não': angular.noop,
                    'Sim': () => {
                        this.$apply(() => {
                            coletorConfig.deletePromise = this
                                .gql
                                .mutate(query, variables)
                                .then(({ config }) => {
                                    this.coletor.configs = this
                                        .coletor
                                        .configs
                                        .filter(({ id: configId }) => configId !== config.id)
                                })
                                .then(() => this.$apply())
                                .catch(console.error)
                        })
                    }
                }
            )
    }

    updateConfig(coletorConfig) {
        const query = gql`
            mutation UpdateColetorConfig($configId: Int!, $diretorio: String!) {
                config: updateColetorConfig(id: $configId, diretorio: $diretorio) {
                    id
                    diretorio
                    status
                }
            }
        `

        const variables = {
            configId: parseInt(coletorConfig.id),
            diretorio: coletorConfig.diretorio
        }

        coletorConfig.updatePromise = this
            .gql
            .mutate(query, variables)
            .then(({ config: { id, diretorio, status } }) => {
                coletorConfig.editing = false
                coletorConfig.diretorio = diretorio
                coletorConfig.status = status
            })
            .then(() => this.$apply())
            .catch(console.error)
    }

    openConfig() {
        this.showConfigs = !this.showConfigs
    }

    newConfig() {
        this.isOpen = true
        this.coletorConfig = {
            coletor: this.coletor
        }
    }

    hasError() {
        return this.coletor.configs.some(config => config.status != 'ATIVO')
    }

    onNewConfigCancel() {
        this.coletorConfig = undefined
        this.isOpen = this.coletor.configs.length
    }
}

angular
    .module('eficienciaFiscalModule')
    .component('coletorDetails', {
        controller: ['$element', '$scope', 'gql', ColetorDetails],
        bindings: {
            coletor: '<',
            loading: '<',
            onRemove: '&',
            empresas: '<'
        },
        template: `
            <div class="well well-xs">
                <div class="row">
                    <div class="col-xs-9 col-lg-10">
                        <h3>
                            {{$ctrl.coletor.nome}}
                            <small class="text-muted">{{$ctrl.coletor.versao}}</small>
                        </h3>
                        <small class="text-muted" ng-if="$ctrl.coletor.ultimoEnvio">Último envio: {{$ctrl.coletor.ultimoEnvio | date: 'dd/MM/yyyy hh:mm:ss'}}</small>
                        <small class="text-muted" ng-if="!$ctrl.coletor.ultimoEnvio">Nenhum envio</small>
                    </div>
                    <div class="col-xs-3 col-lg-2">
                        <span ng-switch="$ctrl.coletor.status" class="pull-right">
                            <span ng-switch-when="ATIVO" class="label label-success">Ativo</span>
                            <span ng-switch-when="INATIVO" class="label label-danger">Inativo</span>
                            <span ng-switch-when="NAO_CONFIGURADO" class="label label-warning">Não configurado</span>
                        </span>
                        <br>
                        <div class="pull-right" style="margin-top: 12px" >
                            <a
                                class="cursor-pointer" 
                                ng-hide="$ctrl.loading"
                                ng-click="$ctrl.onRemove({$event: $event, coletor: $ctrl.coletor})">
                                Desinstalar
                            </a>
                            <span ng-show="$ctrl.loading">
                                Desinstalando... <i class="fa fa-spinner fa-spin"></i>
                            </span>
                        </div >
                    </div>
                </div>
                <div class="row coletor-configs slide-animation" delay="300" ng-show="$ctrl.isOpen">
                    <div class="col-xs-12">
                        <div ng-if="$ctrl.coletorConfig">
                            <promise-tracker promise="$ctrl.createPromise">
                                <coletor-config-form 
                                    coletor-config="$ctrl.coletorConfig" 
                                    on-save="$ctrl.createConfig(coletorConfig)"
                                    loading="$parent.$tracker.active"
                                    empresas="$ctrl.empresas"
                                    on-cancel="$ctrl.onNewConfigCancel()">
                                </coletor-config-form>
                            </promise-tracker>
                        </div>
                        <div class="text-right" style="margin-bottom: 7px" ng-if="$ctrl.coletor.configs.length && !$ctrl.coletorConfig">
                            <a class="cursor-pointer" ng-if="$ctrl.empresas.length" ng-click="$ctrl.newConfig()">Adicionar configuração</a>
                        </div>
                        <div class="config-item" ng-repeat="config in $ctrl.coletor.configs track by config.id">
                            <promise-tracker promise="config.deletePromise" active="config.isLoading">
                                <coletor-config-details 
                                    coletor-config="config" 
                                    ng-if="!config.editing"
                                    on-edit-config="config.editing = true"
                                    loading="config.isLoading"
                                    on-remove-config="$ctrl.deleteConfig(coletorConfig)">
                                </coletor-config-details>
                            </promise-tracker>
                            <promise-tracker promise="config.updatePromise" active="config.isLoading">
                                <coletor-config-form 
                                    coletor-config="config"
                                    ng-if="config.editing"
                                    editing="config.editing"
                                    loading="config.isLoading"
                                    empresas="$ctrl.empresas"
                                    on-save="$ctrl.updateConfig(coletorConfig)"
                                    on-cancel="config.editing = false">
                                </coletor-config-form>
                            </promise-tracker>
                        </div>
                    </div>
                </div>
                <div class="row see-more" ng-hide="$ctrl.loading">
                    <div class="col-xs-12 text-center">
                        <a class="cursor-pointer" ng-click="$ctrl.isOpen = !$ctrl.isOpen" ng-if="$ctrl.coletor.configs.length">
                            <span ng-hide="$ctrl.isOpen" class="transition see-more-text">
                                Ver configurações
                                <i ng-if="$ctrl.hasError()" class="fa fa-exclamation-triangle text-danger"></i>
                            </span>
                            <span ng-hide="!$ctrl.isOpen" class="transition see-more-text">
                                Esconder configurações
                            </span>
                            <br>
                            <i class="fa fa-angle-down transition" ng-class="{'fa-rotate-180': $ctrl.isOpen}"></i>
                        </a>

                        <a class="cursor-pointer" ng-click="$ctrl.newConfig()" ng-if="!$ctrl.coletor.configs.length && !$ctrl.coletorConfig && $ctrl.empresas.length">
                            <span class="transition">Adicionar configurações</span>
                        </a>

                        <span class="text-muted" ng-if="!$ctrl.coletor.configs.length && !$ctrl.coletorConfig && !$ctrl.empresas.length">
                            Você não possui acesso administrador em nenhuma empresa.
                        </span>
                    </div>
                </div>
            </div>
        `
    })
